import api, { Notifiable } from "../api";

const controller = '/naoConformidadeDiretoriaEstatutaria';


export interface DiretoriaEstatutariaProps {
  id: string;
  usuarioId: string;
  usuarioNome: string;
  name: string;
}


export interface DiretoriaEstatutariaResultProps {
  numeroLinha: number;
  id: string;
  sequence: number;
  usuarioId: string;
  usuarioNome: string;
}


export const getAllDiretoriaEstatutaria = async () => {
  return await api.get<Array<DiretoriaEstatutariaResultProps>>(`${controller}`);
}


export const getByIdDiretoriaEstatutaria = async (id: string) => {
  return await api.get<DiretoriaEstatutariaResultProps>(`${controller}/${id}`);
}


export const deleteDiretoriaEstatutaria = async (id: string) => {
  return await api.delete(`${controller}/${id}`);
}


export const postDiretoriaEstatutaria = async (form: DiretoriaEstatutariaProps) => {
  return await api.post<Notifiable>(`${controller}`, form);
}

export const updateDiretoriaEstatutaria = async (form: DiretoriaEstatutariaProps) => {
  return await api.put<Notifiable>(`${controller}`, form);
}